import { useMutation, useQueryClient } from '@tanstack/react-query';
import { abrirCompetencia } from '../api/FechamentoApi';
import type { FechamentoCompetenciaPayload, FecharAbrirCompetenciaResponse } from '../api/types';

export function useAbrirCompetencia() {
  const queryClient = useQueryClient();

  return useMutation<FecharAbrirCompetenciaResponse, Error, FechamentoCompetenciaPayload>({
    mutationFn: abrirCompetencia,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['status-fechamento-snac'] });
    },
  });
}
